export const STOCK_TYPES = {
  LIMITED: 'LIMITED',
  UNLIMITED: 'UNLIMITED',
};